import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=7ffde2d3&scoped=true&"
import script from "./SortSelect.vue?vue&type=script&lang=js&"
export * from "./SortSelect.vue?vue&type=script&lang=js&"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=7ffde2d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffde2d3",
  null
  
)

export default component.exports